import React from 'react'
import {createPortal} from 'react-dom'
import {Modal} from 'react-bootstrap'

const modalsRoot = document.getElementById('root-modals') || document.body

const optionalPositiveInteger = (value) => {
  if(value === '') return undefined
  const parsedValue = Number.parseInt(value, 10)
  return Number.isInteger(parsedValue) && parsedValue > 0 ? parsedValue : undefined
}

const PricingRuleDetailModal = ({show, handleClose, pricingRule, setPricingRule, onSubmit, onDelete}) => {
  const updateData = (fieldsToUpdate) => {
    setPricingRule({...pricingRule, ...fieldsToUpdate})
  }

  const updateCondition = (condition, value) => {
    const conditions = {
      ...(pricingRule?.conditions || {}),
      [condition]: optionalPositiveInteger(value),
    }
    if(condition === 'min_dates') delete conditions.min_days
    if(conditions[condition] === undefined) delete conditions[condition]
    updateData({conditions})
  }

  return createPortal(
    <Modal
      id='kt_modal_pricing_rule'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog modal-dialog-centered mw-700px'
      show={show}
      onHide={handleClose}
      backdrop={true}
    >
      <div className='modal-header'>
        <h2>{pricingRule?.id ? 'Update Pricing Rule' : 'Create Pricing Rule'}</h2>
      </div>

      <div className='modal-body py-lg-10 px-lg-10'>
        <div className='flex-row-fluid py-lg-5 px-lg-10'>
          <div className='fv-row mb-8'>
            <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
              <span className='required'>Name</span>
            </label>
            <input
              type='text'
              className='form-control form-control-lg form-control-solid'
              name='pricing-rule-name'
              value={pricingRule?.name || ''}
              onChange={(event) => updateData({name: event.target.value})}
            />
          </div>

          <div className='fv-row mb-8'>
            <label className='d-flex align-items-center fs-5 fw-semibold mb-3'>Conditions</label>
            <div className='row g-4'>
              <div className='col-sm-6'>
                <label className='mb-2'>Minimum people</label>
                <input
                  type='number'
                  min='1'
                  step='1'
                  className='form-control form-control-lg form-control-solid'
                  name='pricing-rule-min-people'
                  placeholder='No minimum'
                  value={pricingRule?.conditions?.min_people || ''}
                  onChange={(event) => updateCondition('min_people', event.target.value)}
                />
              </div>
              <div className='col-sm-6'>
                <label className='mb-2'>Minimum dates</label>
                <input
                  type='number'
                  min='1'
                  step='1'
                  className='form-control form-control-lg form-control-solid'
                  name='pricing-rule-min-dates'
                  placeholder='No minimum'
                  value={pricingRule?.conditions?.min_dates || pricingRule?.conditions?.min_days || ''}
                  onChange={(event) => updateCondition('min_dates', event.target.value)}
                />
              </div>
            </div>
            <div className='text-muted mt-3'>All defined conditions must match for this rule to apply.</div>
          </div>

          <div className='fv-row mb-10'>
            <div className='form-check form-switch form-check-custom form-check-solid'>
              <input
                className='form-check-input'
                type='checkbox'
                id='pricing-rule-active'
                checked={pricingRule?.active !== false}
                onChange={(event) => updateData({active: event.target.checked})}
              />
              <label className='form-check-label' htmlFor='pricing-rule-active'>Active</label>
            </div>
          </div>

          <div className='d-flex flex-row-fluid justify-content-between align-items-center gap-3'>
            <div>
              {pricingRule?.id && (
                <button type='button' className='btn btn-lg btn-danger' onClick={onDelete}>Delete</button>
              )}
            </div>
            <div className='d-flex gap-3'>
              <button type='button' className='btn btn-lg' onClick={handleClose}>Close</button>
              <button type='button' className='btn btn-lg btn-primary' onClick={onSubmit}>
                {pricingRule?.id ? 'Update' : 'Create'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </Modal>,
    modalsRoot
  )
}

export default PricingRuleDetailModal
